// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_CardSetupErrorType from "../Ouroboros.Models.Brands.CardSetupErrorType/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_PromoCodeStatus from "../Ouroboros.Models.Brands.PromoCodeStatus/index.js";
import * as Ouroboros_Models_Documents_Documents from "../Ouroboros.Models.Documents.Documents/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var BillingInfo = function (x) {
    return x;
};
var tsBridgeBillingInfo = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeConstructor(new DTS_Types.TsQualName(new Data_Maybe.Just(new DTS_Types.TsImportPath("@services/CreditCardService")), new DTS_Types.TsName("BillingInfo")), [  ]));
    }
};
var validateSetupIntentResponse = function (response) {
    return Ouroboros_Models_Documents_Documents.isNonEmpty(response.setup_intent_secret);
};
var validateGetPublishableKeyResponse = function (response) {
    return Ouroboros_Models_Documents_Documents.isNonEmpty(response.stripe_publishable_key);
};
var stripeConnectionError = function (description) {
    return {
        type: Ouroboros_Models_Brands_CardSetupErrorType.makeCardSetupErrorType("StripeConnectionError"),
        message: new Data_Maybe.Just(Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(description))
    };
};
var showBillingInfo = Data_Show.showString;
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "setup_intent_secret";
    }
})(Simple_JSON.readString)(Simple_JSON.readFieldsNil)()()));
var readJson2 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "promo_status";
    }
})(Ouroboros_Models_Brands_PromoCodeStatus.readPromoCodeStatus)(Simple_JSON.readFieldsNil)()()));
var readJson3 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "stripe_publishable_key";
    }
})(Simple_JSON.readString)(Simple_JSON.readFieldsNil)()()));
var makeBillingInfo = BillingInfo;
var isPromoCodeStatus = function (status) {
    var value = Ouroboros_Models_Brands_PromoCodeStatus.unwrap(status);
    return value === "Valid" || (value === "Not Found" || (value === "Expired" || value === "Used"));
};
var validatePromoCodeResponse = function (response) {
    return isPromoCodeStatus(response.promo_status);
};
var initializationError = /* #__PURE__ */ (function () {
    return {
        type: Ouroboros_Models_Brands_CardSetupErrorType.makeCardSetupErrorType("InitializationError"),
        message: Data_Maybe.Nothing.value
    };
})();
var failWith = function (message) {
    return new Data_Either.Left(message);
};
var eqBillingInfo = Data_Eq.eqString;
var decodeSetupIntentResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $36 = validateSetupIntentResponse(decoded);
        if ($36) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid setup intent payload");
    });
};
var decodePromoCodeResponse = function (value) {
    return bind(readJson2(value))(function (decoded) {
        var $37 = validatePromoCodeResponse(decoded);
        if ($37) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid promo code payload");
    });
};
var decodeGetPublishableKeyResponse = function (value) {
    return bind(readJson3(value))(function (decoded) {
        var $38 = validateGetPublishableKeyResponse(decoded);
        if ($38) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid publishable key payload");
    });
};
var cardElementError = /* #__PURE__ */ (function () {
    return {
        type: Ouroboros_Models_Brands_CardSetupErrorType.makeCardSetupErrorType("CardElementError"),
        message: Data_Maybe.Nothing.value
    };
})();
var addressElementError = /* #__PURE__ */ (function () {
    return {
        type: Ouroboros_Models_Brands_CardSetupErrorType.makeCardSetupErrorType("AddressElementError"),
        message: Data_Maybe.Nothing.value
    };
})();
export {
    makeBillingInfo,
    initializationError,
    cardElementError,
    addressElementError,
    stripeConnectionError,
    decodeGetPublishableKeyResponse,
    decodeSetupIntentResponse,
    decodePromoCodeResponse,
    eqBillingInfo,
    showBillingInfo,
    tsBridgeBillingInfo
};
//# sourceMappingURL=index.js.map
